import { store$ } from '@redux/store';
import { distinctUntilChanged, filter, map, skip } from 'rxjs';
import { selectCurrentUrl } from 'features/routing';


/**
 * Updates the canonical URL meta tag in the document head.
 * @param {string} canonicalUrl - The new canonical URL to set
 * @returns {void}
 */
function updateCanonical(canonicalUrl) {
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonicalUrl && canonical) {
    canonical.setAttribute('href', canonicalUrl);
  }
}

// observer to map current page url but only emit if the current url have been changed
const onCurrentPageChange$ = store$.pipe(
  map(selectCurrentUrl),
  filter(Boolean),
  distinctUntilChanged(),
  skip(1)
);

onCurrentPageChange$.subscribe(updateCanonical);
